export default "__VITE_ASSET__CS6AbAy2__"